export const isEmpty = (variable: object | string[] | string | number | boolean | undefined): boolean => {
  const isEmpty = false;

  if (typeof variable === 'undefined' || variable === '' || variable === null || variable === 0) {
    return true;
  }

  if (typeof variable === 'object' && Object.keys(variable).length <= 0) {
    return true;
  }

  return isEmpty;
};
